module.exports = __webpack_public_path__ + "static/img/expansion-logo.c3f7065d.png";